<template>
  <div class="flex gap-1 nested-menu-tab-button-container">
    <nested-menu-tab-button :title="$t('sent_history')" icon="icon-list" route="messageManagement.sentHistory"></nested-menu-tab-button>
    <nested-menu-tab-button :title="$t('received_history')" icon="icon-list" route="messageManagement.receivedHistory"></nested-menu-tab-button>
  </div>
</template>

<script>
import NestedMenuTabButton from '@/components/navigations/NestedMenuTabButton'

export default {
  name: 'Shared.MessageManagement.TabNav',
  components: {
    NestedMenuTabButton
  }
}
</script>

<style scoped>

</style>
